import { createContext, useContext, useRef, ReactNode, useState } from "react";

interface ChatScrollContextType {
  bottomRef: React.RefObject<HTMLDivElement | null>;
  containerRef: React.RefObject<HTMLDivElement | null>;
  shouldScroll: boolean;
  setShouldScroll: React.Dispatch<React.SetStateAction<boolean>>;
}

const ChatScrollContext = createContext<ChatScrollContextType | undefined>(
  undefined
);

export const ChatScrollProvider = ({ children }: { children: ReactNode }) => {
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [shouldScroll, setShouldScroll] = useState(true);

  return (
    <ChatScrollContext.Provider
      value={{ bottomRef, containerRef, shouldScroll, setShouldScroll }}
    >
      {children}
    </ChatScrollContext.Provider>
  );
};

export const useChatScrollContext = () => {
  const context = useContext(ChatScrollContext);
  if (!context) {
    throw new Error(
      "useChatScrollContext must be used within ChatScrollProvider"
    );
  }
  return context;
};
